import React from "react";
import LegalModal from "../pages/LegalModal";
import { LEGAL_VERSION } from "../legalVersion";

/**
 * Props:
 *  - as: "inline" | "menu"      → render compacto o con separación
 *  - className: string          → clases extra para el contenedor
 *  - variant: "compact" | "comfy" | "wide"  → ANCHO del modal (default: "comfy")
 *  - showVersion: boolean       → muestra vX.Y.Z junto al enlace (default: true)
 *  - linkClassName: string      → clases extra para los enlaces/botones
 */
export default function LegalQuickLinks({
  as = "inline",
  className = "",
  variant = "comfy",
  showVersion = true,
  linkClassName = "underline underline-offset-2 hover:text-indigo-700 transition-colors",
}) {
  const [open, setOpen] = React.useState(false);

  const Inline = (
    <span className={className}>
      <button
        type="button"
        className={linkClassName}
        onClick={() => setOpen(true)}
        aria-haspopup="dialog"
        aria-expanded={open}
      >
        Aviso legal y Privacidad{showVersion ? ` (v${LEGAL_VERSION})` : ""}
      </button>
      {" · "}
      {/* <a
        className={linkClassName}
        href="/legal"
        rel="noopener noreferrer"
      >
        Ver página
      </a> */}
    </span>
  );

  const Menu = (
    <div className={`${className} flex items-center gap-3`}>
      <button
        type="button"
        className={linkClassName}
        onClick={() => setOpen(true)}
        aria-haspopup="dialog"
        aria-expanded={open}
      >
        Aviso legal{showVersion ? ` (v${LEGAL_VERSION})` : ""}
      </button>
      {/*<a
        className={linkClassName}
        href="/legal"
        rel="noopener noreferrer"
      >
        Página legal
      </a>
      */}
    </div>
  );

  return (
    <>
      {as === "menu" ? Menu : Inline}

      <LegalModal
        open={open}
        onClose={() => setOpen(false)}
        version={LEGAL_VERSION}
        variant={variant}   // ⬅️ controla el ancho del modal
      />
    </>
  );
}
